import { LlmTositeLukuSettijasenyys } from '../../../_jaettu-lemonator/model/llm-tosite-luku-testaus'

export const ryhmitteleSettijasenyydetTositteittain = (jasenyydet: LlmTositeLukuSettijasenyys[]): Map<string, LlmTositeLukuSettijasenyys[]> => {
  const tositteittain = new Map<string, LlmTositeLukuSettijasenyys[]>()
  for (const jasenyys of jasenyydet) {
    const lista = tositteittain.get(jasenyys.tositeAvain) ?? []
    lista.push(jasenyys)
    tositteittain.set(jasenyys.tositeAvain, lista)
  }
  return tositteittain
}
